import { useEffect, useState, useRef } from 'react';
// import { useTranslation } from "react-i18next";
import { Viewer } from '@photo-sphere-viewer/core';
import { AutorotatePlugin } from '@photo-sphere-viewer/autorotate-plugin';
import '@photo-sphere-viewer/core/index.css';
// import * as exifr from 'exifr';
import { checkVrFileByFileUrl } from 'data/data';

export function PanoViewer({fileUrl, hSize='100%'}) {
    // const { t } = useTranslation();
  
    const [imageUrl, setImageUrl] = useState(null);
    const [is360, setIs360] = useState(null);
    const viewerRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(()=>{
      if (fileUrl) {
        checkVrFileByFileUrl(fileUrl).then((result) => {
          if (result) {
            setImageUrl(result.url);
            setIs360(result.is360)
          }
        });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[fileUrl]);

    // const setImageFromFile = async(fileUrl) => {
    //   try {
    //     const response = await fetch(fileUrl); // 실제 API 주소로 변경
    //     const blob = await response.blob();
    //     const { url, is360 } = await checkImageFromBlob(blob);
    //     setImageUrl(url);
    //     setIs360(is360);
    //   } catch (error) {
    //     console.error('이미지 다운로드 실패:', error);
    //   }
    // };

    useEffect(() => {
      // if (is360 && imageUrl && containerRef.current) {
      if ( imageUrl && containerRef.current) {
        if (viewerRef.current) {
          viewerRef.current.destroy();
        }

        viewerRef.current = new Viewer({
          panorama: imageUrl,
          container: containerRef.current,
          // ✅ 자동 회전 활성화
          plugins: [
              [AutorotatePlugin, {
                  autostartDelay: 1000,
                  // autorotatePitch: '5deg',
                  autorotateSpeed: '1rpm',
              }],
          ],
        });
      }

      // return () => {
      //   viewerRef.current?.destroy();
      // };
    }, [is360, imageUrl]);

    return (
      <div className='player-wrapper' style={{width:"1200px", height: hSize}}>
        {imageUrl && is360 === true && (
          <div ref={containerRef} style={{ width: '1200px', height: '520px', maxHeight: '520px'}} />
        )}
        {imageUrl && is360 === false && (
          <img src={imageUrl} alt="uploaded" style={{ width: '1200px', height: '520px', maxHeight: '520px' }} />
        )}
      </div>
    )
  }
  
  export default PanoViewer;
  